export enum Type {
    BONDED_DECON = "Bonded Decon",
    DIRECT_DIRECT = "Direct Direct",
}